(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-size-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var picker = btn.closest('.card-size-picker');
    picker.querySelectorAll('.card-size-btn').forEach(function (b) {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    var card = btn.closest('[data-card-product]');
    if (card) {
      card.dataset.selectedVariant = btn.dataset.variantId;
      var c = card.querySelector('.card-cta');
      if (c) c.classList.remove('is-added');
    }
  }, true);

  function drawerSectionId() {
    var el = document.querySelector('cart-drawer');
    var host = el && el.closest('.shopify-section');
    if (!host || !host.id) return null;
    return host.id.replace(/^shopify-section-/, '');
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('.card-cta');
    if (!cta) return;
    if (getComputedStyle(cta).display === 'none') return;

    var vLabel = cta.querySelector('.cta-label--variant');
    if (!vLabel || getComputedStyle(vLabel).display === 'none') return;

    var card = cta.closest('[data-card-product]');
    if (!card) return;

    var id = card.dataset.selectedVariant || card.dataset.defaultVariant;
    if (!id) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (cta.classList.contains('is-loading')) return;
    cta.classList.add('is-loading');

    var sectionId = drawerSectionId();
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        var live = document.querySelector('cart-drawer');
        var html = data.sections && sectionId ? data.sections[sectionId] : null;

        if (html && live) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          if (fresh) live.replaceWith(fresh);
        }

        live = document.querySelector('cart-drawer');
        if (live && typeof live.openCartDrawer === 'function') {
          live.openCartDrawer();
        }

        cta.classList.add('is-added');
        setTimeout(function () { cta.classList.remove('is-added'); }, 2000);
      })
      .catch(function () {
        window.location.href = cta.getAttribute('href') || '/cart';
      })
      .finally(function () {
        cta.classList.remove('is-loading');
      });
  }, true);
})();